export const urls = {
    getCategory: 'https://backend-final-1-latest.onrender.com/api/products/category',
    getCategories: 'https://backend-final-1-latest.onrender.com/api/categories', 
    getProductDetail: 'https://backend-final-1-latest.onrender.com/api/products',
    getProductsBySearch: 'https://backend-final-1-latest.onrender.com/api/products/search?search=',
    isCartExist: "https://backend-final-1-latest.onrender.com/api/carts/user",
    updateCart:"https://backend-final-1-latest.onrender.com/api/carts", 
    createCart:"https://backend-final-1-latest.onrender.com/api/carts",
    getBrands: "https://backend-final-1-latest.onrender.com/api/brands",
};
